// extracted by mini-css-extract-plugin
export var active = "_98-a";
export var activeIndicator = "_98-9";
export var disabled = "_98-b";
export var fullWidth = "_98-2";
export var lg = "_98-7";
export var md = "_98-6";
export var redoButtonTabGroup = "_98-0";
export var sm = "_98-5";
export var tabButton = "_98-4";
export var tabButtonsContainer = "_98-1";
export var themeDestructive = "_98-d";
export var themeNormal = "_98-c";
export var themeSuccess = "_98-e";
export var xl = "_98-8";
export var xs = "_98-3";